<script setup>
import { useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import BookingSubMenu from '@/Includes/BookingSubMenu.vue';
import { ref, onMounted } from "vue";
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { Modal } from 'bootstrap';

const props = defineProps({
    year: String,
    bookingById: Object,
    flash: Object,
    agent: Object,
    user: Object,
});

let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
const $toast = useToast();
let menu = 'details';
dayjs.extend(advancedFormat);

function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
    if (props.flash.message) {
        $toast.open({
            message: props.flash.message,
            type: "info",
            duration: 4000,
            position: 'top-right',
            class: 'bs-toast toast bg-dark show'
        });
    }
});

const FlightDetailsForm = useForm({
    arrival_flight: '',
    departure_flight: '',
    booking_id: props.bookingById.id,
});

const UpdateResortAmountForm = useForm({
    resort_amount: '',
    booking_id: props.bookingById.id,
});

const BookingCancelForm = useForm({
    cancelled_reason: '',
    booking_id: props.bookingById.id,
});

const BookingConfirmForm = useForm({
    resort_confirmation_number: '',
    sendmailtoagent: false,
    booking_id: props.bookingById.id,
});

const FlightDetailsUpdateFormSubmit = () => {
    FlightDetailsForm.post('/bookings/updatearrvdept', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide();
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

const UpdateResortAmountFormSubmit = () => {
    UpdateResortAmountForm.post('/bookings/updateresortamount', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide();
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

const BookingCancelFormSubmit = () => {
    BookingCancelForm.post('/bookings/cancel', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide();
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

const BookingConfirmFormSubmit = () => {
    BookingConfirmForm.post('/bookings/confirmbooking', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide();
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

function FormReset() {
    FlightDetailsForm.reset();
    FlightDetailsForm.clearErrors();
    BookingCancelForm.reset();
    BookingCancelForm.clearErrors();
    BookingConfirmForm.reset();
    BookingConfirmForm.clearErrors();
    thisModalObj.hide();
}
</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Booking Details" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <BookingSubMenu :bookingById="bookingById" :agent="agent" :menu="menu" />
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-primary">Booking Details</h5>
                            <div v-if="bookingById.status == 'Cancelled'" class="alert alert-danger" role="alert">{{
                                bookingById.cancelled_reason
                            }}</div>
                            <div class="row g-3">
                                <span class="col-md-4">
                                    <ul class="list-unstyled mb-4 mt-3">
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Hotel
                                                Name:</span>
                                            <span>{{ bookingById.hotel.name }}</span>
                                        </li>
                                        <li v-if="bookingById.stay_type == 0" class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Stay
                                                Type:</span>
                                            <span>Full Stay</span>
                                        </li>
                                        <li v-else class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Stay
                                                Type:</span>
                                            <span>Split Stay</span>
                                        </li>
                                        <li v-for="roomtype in bookingById.booking_rooms" :key="roomtype.id"
                                            class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i>
                                            <span v-if="bookingById.stay_type == 1" class="fw-bold mx-2 ">Room
                                                Type:</span>
                                            <span v-else class="fw-bold mx-2 ">Room Type:</span>
                                            <span>{{ roomtype.room_category?.name }} <b>For</b> {{
                                                roomtype.nights
                                            }}
                                                Nights</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Meal
                                                Type:</span>
                                            <span>{{ bookingById.meal_type }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Resort
                                                Confirmation No:</span>
                                            <span style="width:220px;">{{
                                                bookingById.resort_confirmation_number
                                            }}</span>
                                        </li>

                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Resort
                                                Amount:</span>
                                            <span><b>$</b>{{ formatPrice(bookingById.resort_amount) }}</span>
                                        </li>
                                    </ul>
                                </span>
                                <span class="col-md-4">
                                    <ul class="list-unstyled mb-4 mt-3">
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Check
                                                in:</span>
                                            <span>{{
                                                dayjs(bookingById.arrival_date).format('Do MMMM YYYY')
                                            }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Check
                                                out:</span>
                                            <span>{{
                                                dayjs(bookingById.departure_date).format('Do MMMM YYYY')
                                            }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Arrival
                                                Transfer By:</span>
                                            <span>{{ bookingById.transfers[0]?.vessel }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Departure
                                                Transfer By:</span>
                                            <span>{{ bookingById.transfers[1]?.vessel }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Number of
                                                Rooms:</span>
                                            <span>{{ bookingById.no_rooms }} Room</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Agent:</span>
                                            <span>{{ bookingById.agent.agency_name }}</span>
                                        </li>
                                    </ul>
                                </span>
                                <span class="col-md-4">
                                    <ul class="list-unstyled mb-4 mt-3">

                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Arrival
                                                from:</span>
                                            <span>{{ bookingById.arrival_flight }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Departure
                                                from:</span>
                                            <span>{{ bookingById.departure_flight }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Offer
                                                Code:</span>
                                            <span>{{ bookingById.offer_code }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span
                                                class="fw-bold mx-2 ">Nationality:</span>
                                            <span>{{ bookingById.countries[0].name }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Created
                                                By:</span>
                                            <span>{{ bookingById.user?.email ?? '' }}</span>
                                        </li>
                                        <li class="d-flex align-items-center mb-3">
                                            <i class="bx bx-chevron-right"></i><span class="fw-bold mx-2 ">Booking
                                                Payment Deadline:</span>
                                            <span>{{
                                                dayjs(bookingById.booking_payment_deadline).format('Do MMMM YYYY')
                                            }}</span>
                                        </li>
                                    </ul>
                                </span>
                                <div class="alert alert-dark d-flex mb-0" role="alert">
                                    <span class="badge badge-center rounded-pill bg-success  p-3 me-2"><i
                                            class="bx bx-info-circle fs-1"></i></span>
                                    <div class="d-flex flex-column ps-1">
                                        <h6 class="alert-heading d-flex align-items-center fw-bold mb-1">Remarks
                                        </h6>
                                        <span v-html="bookingById.remarks"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addEditFlightDetailsModal" tabindex="-1" aria-modal="true" role="dialog"
            ref="modalShow">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Flight Details</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="FlightDetailsUpdateFormSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="first_name" class="form-label"><b>Arrival Info</b></label>
                                    <input type="text" v-model="FlightDetailsForm.arrival_flight" name="arrival_flight"
                                        class="form-control" placeholder="Arrival Flight No" required="required">
                                </div>
                                <div class="col-md-6">
                                    <label for="last_name" class="form-label"><b>Departure Info</b></label>
                                    <input type="text" v-model="FlightDetailsForm.departure_flight"
                                        name="departure_flight" class="form-control" placeholder="Departure Flight No"
                                        required="required" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="updateResortAmountModal" tabindex="-1" aria-modal="true" role="dialog"
            ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Resort Invoice Amount</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="UpdateResortAmountFormSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="first_name" class="form-label"><b>Resort Invoice Amount</b></label>
                                    <input type="number" step=".01" v-model="UpdateResortAmountForm.resort_amount"
                                        name="resort_amount" class="form-control" placeholder="Resort invoice amount"
                                        required="required">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="cancelBookingModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Booking Cancellation</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="BookingCancelFormSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="first_name" class="form-label"><b>Canceling Reason</b></label>
                                    <textarea class="form-control" v-model="BookingCancelForm.cancelled_reason"
                                        name="cancelled_reason" placeholder="Type a reason to cancel!"
                                        required></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="bookingComfirmModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-top">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Booking Confirmation</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="BookingConfirmFormSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="first_name" class="form-label"><b>Confirmation Number</b></label>
                                    <input type="text" name="resort_confirmation_number"
                                        v-model="BookingConfirmForm.resort_confirmation_number" class="form-control"
                                        placeholder="Resort Ref Number" required="required">
                                </div>
                            </div>
                            <div class="row">
                                <div>
                                    <div class="col-md-12 form-check mt-4">
                                        <input type="checkbox" v-model="BookingConfirmForm.sendmailtoagent"
                                            class="form-check-input" name="sendmailtoagent" checked="checked">
                                        <label class="form-check-label" for="customCheck1">Send confirmation mail to
                                            agent</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="BookingConfirmForm.sendmailtoagent" class="px-4">Once you confirm this booking a mail
                            will be dispatched to the agent.</div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>